var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExitIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "exit-1",
    d: "M17.42,14.64c-1.92,0-3.47,1.55-3.47,3.47v27.78c0,1.92,1.55,3.47,3.47,3.47h6.94c1.92,0,3.47,1.55,3.47,3.47s-1.55,3.47-3.47,3.47h-6.94c-5.75,0-10.42-4.67-10.42-10.42v-27.78c0-5.75,4.67-10.42,10.42-10.42h6.94c1.92,0,3.47,1.55,3.47,3.47s-1.55,3.47-3.47,3.47h-6.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "exit-1",
    d: "M55.98,34.55l-13.89,14.39c-1.36,1.41-3.56,1.41-4.92,0s-1.36-3.69,0-5.09l7.97-8.25h-22.86c-1.92,0-3.47-1.61-3.47-3.6s1.55-3.6,3.47-3.6h22.86l-7.97-8.25c-1.36-1.41-1.36-3.69,0-5.09s3.56-1.41,4.92,0l13.89,14.39c1.36,1.41,1.36,3.69,0,5.09h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitIcon);
export default __webpack_public_path__ + "static/media/exitIcon.e9279e602c02c9e17cd6e3d67e071d22.svg";
export { ForwardRef as ReactComponent };